import ArrowButton from "./ArrowButton";
import "../../styles/ReusableStyles/NavigationArrows.css";

const NavigationArrows = ({ onPrev, onNext, onUp, onDown }) => {
  return (
    <div className="navigation-arrows">
      {onPrev && <ArrowButton direction="left" onClick={onPrev} />}
      {onNext && <ArrowButton direction="right" onClick={onNext} />}
      {onUp && <ArrowButton direction="up" onClick={onUp} />}
      {onDown && <ArrowButton direction="down" onClick={onDown} />}
    </div>
  );
};

export default NavigationArrows;
